import React from "react";
// import "./Cancel_order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import { variant_type } from "../../../../../utils/common";

function Cancel_order_details_table({ order, dontShowPrice }) {
  // console.log(order,'order order cancel');

  return (
    <>
      <div className="product_content_holder">
        <div className="product_content">
          <div className="product_detail_inner">
            <div className="left_side">
              <div className="img_holder">
                <img
                  src={process.env.REACT_APP_IMG_URL + order.Product?.image}
                />
              </div>

              <div className="text_holder">
                <div className="product_name">
                  <p>{order?.Product?.name}</p>
                </div>
                <h6>
                  {order?.Product?.variant_type_id === variant_type.Single && (
                    <>
                      <strong>Mattress Size:</strong>{" "}
                      {order?.Product_Variant?.Metal?.name}
                    </>
                  )}

                  {order?.Product?.variant_type_id === variant_type.Double && (
                    <>
                      <strong>Mattress Size:</strong>{" "}
                      {order?.Double_Variant?.Product_Variant?.Metal?.name},{" "}
                      <strong>Thickness:</strong>{" "}
                      {order?.Double_Variant?.Size?.name}{" "}
                    </>
                  )}

                  {order?.Product?.variant_type_id === variant_type.Triple && (
                    <>
                      <p className="sub_text">
                        <strong>Mattress Size:</strong>{" "}
                        {
                          order?.Triple_Variant?.Double_Variant?.Product_Variant
                            ?.Metal?.name
                        }
                        ,{order?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                      </p>
                      <p className="sub_text">
                        <strong>Thickness:</strong>{" "}
                        {order?.Triple_Variant?.Diamond?.name}
                      </p>
                    </>
                  )}
                </h6>
                {/* <p className="sub_text">
                    Mattress Size: 182.9x76.2 cm/72x30 in{" "}
                  </p>
                  <p className="sub_text"> Thickness: 22.86 cm/9 in</p> */}
              </div>
            </div>

            <div>
              <div className="qty_holder">
                <p>
                  <div>Quantity: {order?.quantity}</div> {/* {!dontShowPrice && ( */}
                  <span className="price">
                    ₹{(Number(order?.selling_price)+Number(order?.total_tax)).toFixed(2)}
                  </span>
                  {/* )} */}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='product_content_holder'>
        <div className='product_content'>
          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.REACT_APP_IMG_URL +
                    order?.Product_Order_Details?.Product?.image
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>{order?.Product_Order_Details?.Product_Variant?.name}</p>
                </div>
                <div className='weight'>
                  <p>{order?.total_kg}</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>

          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/products/img2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Apple</p>
                </div>
                <div className='weight'>
                  <p>0.5kg</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>
        </div>
      </div> */}
    </>
  );
}

export default Cancel_order_details_table;
